if (!customElements.get("selling-plan-selector")) {
  class SellingPlanSelector extends HTMLElement {
    constructor() {
      super();
      this.sellingPlanContainer = document.querySelector(".selling-plan");
      this.segmentDiscount = this.dataset.segmentDiscount * 1;

      this.productForm = document.querySelector(`#${this.dataset.productForm}`);

      this.subscriptionGroup = this.querySelector(
        ".selling-plan__group--subscription"
      );
      this.oneTimeGroup = this.querySelector(".selling-plan__group--one-time");
      this.variantInput = document.querySelector(
        `[id="${this.dataset.variantInputId}"]`
      );

      // Watch for selling plan option change to update the selected selling plan
      this.sellingPlanContainer
        .querySelectorAll("select")
        .forEach((optionSelector) => {
          optionSelector.addEventListener("change", (e) => {
            this.querySelector('[name="selling_plan"]').value =
              optionSelector.value;
          });
        });

      this.querySelectorAll("input[type=radio]").forEach((radio) => {
        radio.addEventListener("change", (e) => {
          let sellingPlan = "";
          if (!e.currentTarget.dataset.oneTime) {
            sellingPlan =
              e.currentTarget.parentNode.querySelector("select").value;
          }
          this.querySelector('[name="selling_plan"]').value = sellingPlan;

          publish(PUB_SUB_EVENTS.sellingPlanUpdate, {
            data: {
              sellingPlan: sellingPlan,
            },
          });

          var selectedVariant = findSelectedVariantData(
            this.variantInput.value * 1,
            JSON.parse(
              this.productForm.querySelector('[type="application/json"]')
                .textContent
            )
          );

          publish(PUB_SUB_EVENTS.onPriceUpdate, {
            target: this.productForm.querySelector("product-price"),
            data: {
              price:
                sellingPlan != ""
                  ? selectedVariant.selling_plan_allocations[0].price
                  : selectedVariant.price,
              compareAtPrice:
                selectedVariant.compare_at_price > selectedVariant.price
                  ? selectedVariant.compare_at_price
                  : null,
              isOnetime: sellingPlan == "",
              sellingPlanAllocation:
                selectedVariant.selling_plan_allocations[0], // needed for Klarna
            },
          });
        });
      });
    }
    variantChangedUnsubscriber = undefined;
    connectedCallback() {
      this.variantChangedUnsubscriber = subscribe(
        PUB_SUB_EVENTS.variantChange,
        (event) => {
          if (
            event.target !== this.productForm.querySelector("variant-radios") &&
            event.target !== this.productForm.querySelector("pdp-radios")
          )
            return; // Ensure the event is for this specific element

          if (event.data.variant.selling_plan_allocations.length == 0) return;
          this.subscriptionGroup.querySelector(
            ".selling-plan__price"
          ).innerHTML = Shopify.formatMoney(
            event.data.variant.selling_plan_allocations.length > 0
              ? event.data.variant.selling_plan_allocations[0].price
              : event.data.variant.price,
            "${{amount}}"
          );

          if (this.oneTimeGroup) {
            const finalPrice = this.segmentDiscount
              ? Math.ceil(
                  event.data.variant.selling_plan_allocations[0]
                    .compare_at_price -
                    (event.data.variant.selling_plan_allocations[0]
                      .compare_at_price *
                      this.segmentDiscount) /
                      100
                )
              : event.data.variant.selling_plan_allocations[0].compare_at_price;
            this.oneTimeGroup.querySelector(".selling-plan__price").innerHTML =
              Shopify.formatMoney(finalPrice, "${{amount}}");
          }
        }
      );
    }

    disconnectedCallback() {
      if (this.variantChangedUnsubscriber) {
        this.variantChangedUnsubscriber();
      }
    }
  }

  customElements.define("selling-plan-selector", SellingPlanSelector);
}
if (!customElements.get("klarna-price-info")) {
  class KlarmaPriceInfo extends HTMLElement {
    constructor() {
      super();
    }

    sellingPlanChangedUnsubscriber = undefined;

    connectedCallback() {
      this.sellingPlanChangedUnsubscriber = subscribe(
        PUB_SUB_EVENTS.sellingPlanUpdate,
        (event) => {
          if (this.dataset.display == "always") {
            this.style.display = "block";
          } else {
            this.style.display = event.data.sellingPlan ? "none" : "block";
          }
        }
      );
    }

    disconnectedCallback() {
      if (this.sellingPlanChangedUnsubscriber) {
        this.sellingPlanChangedUnsubscriber();
      }
    }
  }

  customElements.define("klarna-price-info", KlarmaPriceInfo);
}
